import { withEventContext } from "@codat/analytics";
import useQueryParams from "hooks/useQueryParams";
import { usePageViewedEvent } from "utils";

import CardContainer from "components/CardContainer";
import ErrorCard from "components/ErrorCard";

function ErrorContent() {
  const queryParams = useQueryParams();
  const getErrorCode = (): number => {
    const errorCodeParam = queryParams.get("errorCode");
    if (errorCodeParam) {
      const errorCodeNumber = parseInt(errorCodeParam);
      if (!isNaN(errorCodeNumber)) {
        return errorCodeNumber;
      }
    }
    return 500;
  };

  const errorCode = getErrorCode();

  usePageViewedEvent({
    ready: true,
    data: {
      httpStatusCode: errorCode,
    },
  });

  const correlationId =
    queryParams.get("x-correlation-id") ?? queryParams.get("correlationId");

  const errorMessage = queryParams.get("errorMessage");

  return (
    <CardContainer>
      <ErrorCard
        errorCode={errorCode}
        correlationId={correlationId}
        errorMessage={errorMessage}
      />
    </CardContainer>
  );
}

export const Error = withEventContext(ErrorContent, "Error page");
